import FacebookTableSearchFilter from './FacebookTableSearchFilter.Container';

export default FacebookTableSearchFilter;
